import NextFlockLabelInfo from './NextFlockLabelInfo';

export default NextFlockLabelInfo;
